import React,{useEffect,useMemo,useState} from 'react';
import {useNavigate} from 'react-router-dom';
import API from '../utils/api';

const imageUrl = value => {
  const raw=String(value||'').trim();
  if(!raw) return '';
  if(/^https?:\/\//i.test(raw)) return raw;
  if(raw.startsWith('/uploads/')) return raw;
  if(raw.startsWith('uploads/')) return '/'+raw;
  return '/uploads/'+raw.replace(/^\/+/, '');
};

export default function OwnerWater(){
  const nav=useNavigate();
  const[data,setData]=useState(null),[loading,setLoading]=useState(true),[error,setError]=useState(''),[viewImage,setViewImage]=useState(null);

  useEffect(()=>{
    let alive=true;
    API.get('/property-archive/me')
      .then(r=>{if(alive)setData(r.data)})
      .catch(e=>{if(alive)setError(e.response?.data?.message||'加载失败')})
      .finally(()=>{if(alive)setLoading(false)});
    return()=>{alive=false};
  },[]);

  const meter=useMemo(()=>data?.water?.meters?.[0]||null,[data]);
  const readings=useMemo(()=>Array.isArray(data?.water?.readings)?data.water.readings:[],[data]);
  const latest=readings[0]||null;

  if(loading) return <div style={s.page}><Header nav={nav}/><div style={s.center}>加载中...</div></div>;
  if(error) return <div style={s.page}><Header nav={nav}/><div style={s.errorBox}>⚠️<div style={{marginTop:8}}>{error}</div></div></div>;

  return <div style={s.page}>
    <Header nav={nav}/>
    <main style={s.body}>
      <section style={s.roomCard}>
        <div style={s.room}>🏠 {data?.property?.room_no||'我的房屋'}</div>
        <div style={s.meter}>水表号：{meter?.meter_no||'未登记'}</div>
      </section>

      {!latest ? <div style={s.empty}>暂无抄表记录</div> : <>
        <section style={s.latest}>
          <div style={s.latestLabel}>最近一次抄表</div>
          <div style={s.latestValue}>{latest.reading}<span style={s.unit}> 吨</span></div>
          <div style={s.latestDate}>{dateText(latest.read_date||latest.created_at)}</div>
          {latest.image_path ? <button style={s.latestPhoto} onClick={()=>setViewImage(imageUrl(latest.image_path))}>📷 查看本次抄表照片</button> : <div style={s.noPhotoLight}>本次未上传照片</div>}
        </section>

        <div style={s.historyTitle}>📜 历史记录</div>
        {readings.map((r,i)=>{
          const prev=readings[i+1];
          const usage=prev&&Number.isFinite(Number(r.reading))&&Number.isFinite(Number(prev.reading))
            ? (Number(r.reading)-Number(prev.reading)).toFixed(2):null;
          return <section key={r.id||i} style={s.historyCard}>
            <div style={s.historyTop}>
              <span style={s.historyDate}>{dateText(r.read_date||r.created_at)}</span>
              <b style={s.historyReading}>{r.reading} 吨</b>
            </div>
            <div style={s.historyBottom}>
              {usage!==null ? <span style={{...s.usage,color:Number(usage)>=0?'#389e0d':'#cf1322'}}>本期用量 {Number(usage)>=0?'+':''}{usage} 吨</span> : <span style={s.usage}>首条记录</span>}
              {r.image_path ? <button style={s.photoBtn} onClick={()=>setViewImage(imageUrl(r.image_path))}>📷 查看照片</button> : <span style={s.noPhoto}>无照片</span>}
            </div>
          </section>;
        })}
      </>}
    </main>

    {viewImage && <div style={s.overlay} onClick={()=>setViewImage(null)}>
      <div style={s.viewer} onClick={e=>e.stopPropagation()}>
        <div style={s.viewerHead}><b>抄表现场照片</b><button style={s.close} onClick={()=>setViewImage(null)}>×</button></div>
        <img src={viewImage} alt="抄表现场" style={s.fullImage}/>
        <div style={s.viewerTip}>点击右上角 × 关闭</div>
      </div>
    </div>}
  </div>;
}

function Header({nav}){return <header style={s.header}><button style={s.back} onClick={()=>nav('/')}>← 返回</button><div style={s.title}>💧 我的水表</div><div style={{width:68}}/></header>}
const dateText=v=>v?String(v).replace('T',' ').slice(0,10):'-';
const s={
  page:{minHeight:'100vh',background:'#f1f7ff'},header:{background:'linear-gradient(90deg,#168bbb,#08b6d2)',color:'#fff',display:'flex',alignItems:'center',justifyContent:'space-between',padding:'16px 20px',position:'sticky',top:0,zIndex:30},back:{border:0,borderRadius:8,padding:'8px 12px',background:'rgba(255,255,255,.16)',color:'#fff',fontSize:15},title:{fontWeight:800,fontSize:21},body:{maxWidth:680,margin:'0 auto',padding:16},roomCard:{background:'#fff',borderRadius:14,padding:'18px 20px',boxShadow:'0 2px 10px rgba(0,0,0,.06)',marginBottom:14},room:{fontSize:18,fontWeight:800,color:'#333'},meter:{marginTop:8,color:'#8a8f98'},latest:{background:'linear-gradient(135deg,#078ebd,#08b6ce)',borderRadius:16,color:'#fff',padding:'22px 18px',textAlign:'center',marginBottom:18},latestLabel:{fontSize:15,opacity:.9},latestValue:{fontSize:48,fontWeight:900,margin:'12px 0 5px'},unit:{fontSize:18,fontWeight:700},latestDate:{opacity:.9,fontSize:15},latestPhoto:{marginTop:15,border:'1px solid rgba(255,255,255,.75)',background:'rgba(255,255,255,.15)',color:'#fff',borderRadius:9,padding:'9px 14px',fontWeight:700},noPhotoLight:{marginTop:12,fontSize:12,opacity:.72},historyTitle:{fontSize:18,fontWeight:800,margin:'8px 2px 10px'},historyCard:{background:'#fff',borderRadius:13,padding:'14px 16px',marginBottom:10,boxShadow:'0 2px 8px rgba(0,0,0,.05)'},historyTop:{display:'flex',justifyContent:'space-between',gap:10,alignItems:'center'},historyDate:{color:'#7d858e'},historyReading:{fontSize:18,color:'#145293'},historyBottom:{display:'flex',justifyContent:'space-between',alignItems:'center',gap:10,marginTop:10,paddingTop:9,borderTop:'1px solid #eef1f4'},usage:{fontSize:12,color:'#8a9199'},photoBtn:{border:0,background:'#e8f5ff',color:'#087aaa',borderRadius:8,padding:'7px 10px',fontWeight:700},noPhoto:{fontSize:12,color:'#bbb'},center:{textAlign:'center',padding:60,color:'#999'},empty:{textAlign:'center',padding:60,color:'#aaa'},errorBox:{margin:20,padding:30,textAlign:'center',background:'#fff1f0',color:'#cf1322',borderRadius:12},overlay:{position:'fixed',inset:0,background:'rgba(0,0,0,.82)',zIndex:9999,display:'flex',alignItems:'center',justifyContent:'center',padding:14},viewer:{width:'100%',maxWidth:720,maxHeight:'92vh',background:'#111',borderRadius:12,overflow:'hidden'},viewerHead:{height:48,display:'flex',alignItems:'center',justifyContent:'space-between',padding:'0 14px',color:'#fff',background:'#222'},close:{border:0,background:'transparent',color:'#fff',fontSize:30,lineHeight:1},fullImage:{display:'block',width:'100%',maxHeight:'78vh',objectFit:'contain',background:'#000'},viewerTip:{textAlign:'center',color:'#aaa',fontSize:12,padding:8}
};
